// extracted by mini-css-extract-plugin
export default {"cls1":"mKZHXMUUVeYsAQptA1Fw","cls2":"oUD1zKIZSebXrc7qqXFI mKZHXMUUVeYsAQptA1Fw","strikethrough":"iIGMtt4aNjBKsDhO4Fqg","paid":"xfJJORi1kTM5xExgWtah"};